import { ArrowLeft } from "lucide-react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useInfoContext } from "../components/layout/AppearanceProvider.jsx";
import { Button } from "../components/ui/Button.jsx";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../components/ui/Card.jsx";
import { Input } from "../components/ui/Input.jsx";
import { Label } from "../components/ui/Label.jsx";
import { useToast } from "../hooks/useToast.js";
import { getCurrentUser, sendOTP } from "../services/authService.js";
import { useFormValidation } from "../hooks/useFormValidation.js";
// import { useFormValidation } from "../utils/hooks/useFormValidation";

// Custom validation for this form
const sendOTPValidation = {
  email: {
    required: "Email is required",
    pattern: {
      regex: /^[a-zA-Z0-9][a-zA-Z0-9._%+-]*@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      message: "Invalid email format",
    },
  },
};

export default function SendOTP() {
  const navigate = useNavigate();
  const { toast } = useToast();
  const { setEmail: setContextEmail, setOtpSent } = useInfoContext();
  const [isSendingOtp, setIsSendingOtp] = useState(false);
  const [headingForm, setHeadingForm] = useState("Sign up");

  // Use validation hook
  const { form, errors, touched, handleChange, handleBlur, validateAll } =
    useFormValidation(
      {
        email: "",
      },
      sendOTPValidation
    );

  const { email } = form;

  const handleBack = async () => {
    try {
      const currentUser = await getCurrentUser();

      if (
        currentUser?.success &&
        currentUser.user.user_role === "business_admin"
      ) {
        navigate("/team");
      } else {
        navigate("/");
      }
    } catch (err) {
      toast({
        title: "Error",
        description: err.message || "Something went wrong",
        variant: "destructive",
      });
    }
  };

  const handleSendOtp = async () => {
    if (!validateAll()) {
      toast({
        title: "Validation Error",
        description: "Please enter a valid email address.",
        variant: "destructive",
      });
      return;
    }

    try {
      setIsSendingOtp(true);
      const res = await sendOTP({ email });
      if (res?.success) {
        setContextEmail(email);
        setOtpSent(true);
        toast({
          title: "OTP sent",
          description: "Check your email for the OTP.",
        });
        navigate("/validate-otp");
      } else {
        toast({
          title: "Failed to send OTP",
          description: res?.error || "Try again.",
          variant: "destructive",
        });
      }
    } catch (err) {
      toast({
        title: "Error",
        description: err.message || "Unable to send OTP",
        variant: "destructive",
      });
    } finally {
      setIsSendingOtp(false);
    }
  };

  useEffect(() => {
    const fetchUserRole = async () => {
      try {
        const currentUser = await getCurrentUser();

        // if (currentUser?.success && currentUser.user) {
        if (currentUser?.success && currentUser.user) {
          setHeadingForm("Add Team Member");
        }
      } catch (err) {
        setHeadingForm("Sign up");
      }
    };

    fetchUserRole();
  }, []);

  return (
    <div className="flex flex-col justify-between max-h-[100dvh] min-h-[100dvh] p-4 space-y-4">
      <div className="flex items-center gap-3">
        <Button
          variant="ghost"
          size="icon"
          onClick={handleBack}
          className="rounded-full"
        >
          <ArrowLeft className="w-5 h-5" />
        </Button>
        <h1 className="text-2xl font-bold">{headingForm}</h1>
      </div>

      <form className="space-y-4" onSubmit={(e) => e.preventDefault()}>
        <Card className="p-4 space-y-4">
          <CardHeader className="p-0">
            <CardTitle className="text-lg">Sign up with Email Id</CardTitle>
          </CardHeader>
          <CardContent className="p-0">
            <div className="">
              <Label htmlFor="email">Email *</Label>
              <Input
                id="email"
                name="email"
                type="email"
                placeholder="email@nipralo.com"
                value={email}
                onChange={handleChange}
                onBlur={handleBlur}
                required
                className={errors.email ? "border-red-500" : ""}
              />
              {touched.email && errors.email && (
                <p className="mt-1 text-sm text-red-500">{errors.email}</p>
              )}
            </div>
          </CardContent>

          <div className="flex justify-center">
            <Button
              type="button"
              className="!w-auto h-8 text-xs rounded-full bg-gradient-to-r from-[#00a8b4fa] to-[#00c8d391]"
              onClick={handleSendOtp}
              disabled={isSendingOtp}
            >
              {isSendingOtp ? "Sending..." : "Send OTP To Email"}
            </Button>
          </div>
        </Card>
      </form>
      <div></div>
    </div>
  );
}
